'use client';

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  children: React.ReactNode;
  /**
   * The container element to render the portal into.
   * Defaults to document.body
   */
  containerRef?: React.RefObject<HTMLElement>;
  /**
   * Whether the portal is disabled. If true, children are rendered in place.
   */
  disabled?: boolean;
}

export const Portal: React.FC<PortalProps> = ({ children, containerRef, disabled = false }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (disabled) {
    return <>{children}</>;
  }

  if (!mounted) {
    return null;
  }

  const container = containerRef?.current || document.body;

  return createPortal(children, container);
};

Portal.displayName = 'Portal';
